<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [class]="isShowOrganizationWhiteMessage ? 'd-none' : ''"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <!---------------------------------------- Table Content --------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center tw-px-4 tw-py-3">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- id -->
        <td>
          <span>
            {{ item?.id }}
          </span>
        </td>

        <!-- number -->
        <td>
          <div
            class="tw-mx-3 tw-flex-center tw-p-1 tw-py-2 tw-my-2 tw-text-gray-800 tw-font-medium rounded tw-text-sm"
          >
            <td-value
              class="tw-mt-1"
              copyToClipboard
              [value]="item?.privateNumber"
            ></td-value>
            <!-- <i class="mdi mdi-sim-outline text-warning mdi-18px tw-px-1"></i> -->
          </div>
        </td>

        <!-- userName -->
        <td>
          <div
            class="tw-mx-3 tw-flex-center tw-p-1 tw-py-2 tw-my-2 tw-text-gray-800 tw-font-medium rounded tw-text-sm"
          >
            <td-value
              class="tw-mt-1"
              copyToClipboard
              [value]="item?.userName"
            ></td-value>
            <!-- <i class="mdi mdi-account-outline text-info mdi-18px tw-px-1"></i> -->
          </div>
        </td>

        <!-- enterSms -->
        <td class="tw-py-[5px] large-text tw-text-center tw-cursor-pointer">
          <app-expand-text [placement]="'right'">
            <span
              small-text
              class="tw-text-center tw-text-gray-700 dark:tw-text-gray-300 tw-font-medium tw-p-1 tw-py-2 tw-my-2 rounded tw-text-sm"
              copyToClipboard
            >
              {{ item?.enterSms }}
            </span>
            <div full-text class="full-text-display tw-w-[250px]">
              {{ item?.enterSms }}
            </div>
          </app-expand-text>
        </td>

        <!-- exitSms -->
        <td class="tw-py-[5px] large-text tw-text-center tw-cursor-pointer">
          <app-expand-text [placement]="'right'">
            <span
              small-text
              class="tw-text-center tw-text-gray-700 dark:tw-text-gray-300 tw-font-medium tw-p-1 tw-py-2 tw-my-2 rounded tw-text-sm"
              copyToClipboard
            >
              {{ item?.exitSms }}
            </span>
            <div full-text class="full-text-display tw-w-[250px]">
              {{ item?.exitSms }}
            </div>
          </app-expand-text>
        </td>

        <!-- returnText -->
        <td class="tw-py-[5px] large-text tw-text-center tw-cursor-pointer">
          <app-expand-text [placement]="'right'">
            <span
              small-text
              class="tw-text-center tw-text-gray-700 dark:tw-text-gray-300 tw-font-medium tw-p-1 tw-py-2 tw-my-2 rounded tw-text-sm"
              copyToClipboard
            >
              {{ item?.returnText }}
            </span>
            <div full-text class="full-text-display tw-w-[250px]">
              {{ item?.returnText }}
            </div>
          </app-expand-text>
        </td>

        <!-- cancelText -->
        <td class="tw-py-[5px] large-text tw-text-center tw-cursor-pointer">
          <app-expand-text [placement]="'right'">
            <span
              small-text
              class="tw-text-center tw-text-gray-700 dark:tw-text-gray-300 tw-font-medium tw-p-1 tw-py-2 tw-my-2 rounded tw-text-sm"
              copyToClipboard
            >
              {{ item?.cancelText }}
            </span>
            <div full-text class="full-text-display tw-w-[250px]">
              {{ item?.cancelText }}
            </div>
          </app-expand-text>
        </td>

        <!-- status -->
        <td>
          <span
            *ngIf="item?.status == WhiteMessageStatus.NotChecked"
            [matTooltip]="
              item?.status | enumToText : WhiteMessageStatusEnumValues
            "
          >
            <i class="mdi mdi-circle-slice-4 mdi-20px text-info mdi-spin"></i>
          </span>
          <span
            *ngIf="item?.status == WhiteMessageStatus.Confirmed"
            class="text-success tw-font-medium"
            [matTooltip]="
              item?.status | enumToText : WhiteMessageStatusEnumValues
            "
          >
            <i class="mdi mdi-check-bold mdi-18px text-success"></i>
          </span>
          <span
            *ngIf="item?.status == WhiteMessageStatus.Reject"
            class="text-danger tw-font-medium"
            [matTooltip]="
              item?.status | enumToText : WhiteMessageStatusEnumValues
            "
          >
            <i class="mdi mdi mdi-close-thick mdi-18px text-danger"></i>
          </span>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTimeWithSpace" [value]="item?.created"></td-value>
        </td>

        <!-------------------------------- operations -------------------------------->
        <td class="sticky-td">
          <!-- OrganizationWhiteMessage -->
          <ng-container *ngIf="isShowOperationBtns">
            <a
              (click)="onUpdate(item?.id)"
              class="btn btn-sm"
              [matTooltip]="'common.editStatus' | translate"
            >
              <i
                class="mdi mdi-pencil-outline mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-navyBlue"
              ></i>
            </a>
          </ng-container>

          <!-- OrganizationWhiteMessage -->
          <ng-container *ngIf="!isShowOperationBtns">
            <a
              (click)="onUpdateOrganizationWhiteMessage(item?.id)"
              class="btn btn-sm"
              [matTooltip]="'common.edit' | translate"
            >
              <i
                class="mdi mdi-pencil-outline mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-navyBlue"
              ></i>
            </a>
          </ng-container>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- White Message Form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-white-message-form
    page-form
    [formPageConfig]="formPageConfig"
    [phonebookTypes]="PhonebookTypesEnumValues"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-white-message-form>
</ng-container>

<!-- Organization White Message Form -->
<ng-container *ngIf="isShowOrganizationWhiteMessage">
  <app-organization-white-message-form
    page-form
    [formPageConfig]="organizationWhiteMessageFormPageConfig"
    (closeFormPage)="
      getOrganizationWhiteMessageFormResponse($event);
      showParent = true;
      getParentQueryString()
    "
  >
  </app-organization-white-message-form>
</ng-container>

<!--------------------------------------- Audit ---------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit> </ng-container
><!--------------------------------------- help --------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
